import { render, staticRenderFns } from "./BackTop.vue?vue&type=template&id=0fcb438a&scoped=true"
import script from "./BackTop.vue?vue&type=script&lang=js"
export * from "./BackTop.vue?vue&type=script&lang=js"
import style0 from "./BackTop.vue?vue&type=style&index=0&id=0fcb438a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcb438a",
  null
  
)

export default component.exports